import { makeActionCreator } from '../../utils/ReduxUtils'

export const SET_ERRORS = 'SET_ERRORS'
export const setErrors = makeActionCreator(SET_ERRORS, 'errorMessages')

export const CLEAR_ERRORS = 'CLEAR_ERRORS'
export const clearErrors = makeActionCreator(CLEAR_ERRORS)

export const SET_SUCCESS = 'SET_SUCCESS'
export const setSuccess = makeActionCreator(SET_SUCCESS, 'successMessage')

export const CLEAR_SUCCESS = 'CLEAR_SUCCESS'
export const clearSuccess = makeActionCreator(CLEAR_SUCCESS)

export const SET_GLOBAL_LOADING = 'SET_GLOBAL_LOADING'
export const setGlobalLoading = makeActionCreator(
  SET_GLOBAL_LOADING,
  'isLoading'
)
